import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoreLocalData, getUserData } from "../../../utils/localStorage";
import {
  getBrandStore,
  getBrandStoreById,
  getBrandUsers,
  postBrandStore,
  putBrandStore,
} from "../../../services/StoreUsers/PostStoreUsers";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import AdminMenu from "../../AdminMenu";
import jsQR from "jsqr";
import { Dropdown } from "primereact/dropdown";

const StoreManagementCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, upiData } = location.state || {}; // Fallback to prevent undefined errors

  const [storeInfoData, setStoreInfoData] = useState([]);

  const { storeLocalData } = getStoreLocalData();
  const countryCode = storeLocalData?.countryCode;

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const isWareHouseModel = brandProfileData.wareHouseModel;
  let orderEditModel = brandProfileData.orderEditModel;
  let enabledBrandGarmentInspection = brandProfileData.enabledGarmentInspection;
  let enabledPaymentGateway = brandProfileData.enabledPaymentGateway;
  let enabledBrandLocality = brandProfileData.enabledLocality;
  let enabledGarmentAttribute = brandProfileData.enabledGarmentAttribute;
  let enabledCustomerPreferencePrice =
    brandProfileData.enabledCustomerPreferencePrice;
  let enabledBrandOldOrderFeature = brandProfileData.enabledOldOrderFeature;
  let packageCarryForwardBrand = brandProfileData.packageCarryForward;
  let enabledLoyaltyPointBrand = brandProfileData.enabledLoyaltyPoint;
  // let enabledB2BModelBrand = brandProfileData.enabledB2BModel;
  let enabledRackModelBrand = brandProfileData.enabledRackModel;
  let enabledApplySubscriptionWithPackageBrand = brandProfileData.enabledApplySubscriptionWithPackage;
  let enabledAutoApplySubscriptionWithPackageBrand = brandProfileData.enabledAutoApplySubscriptionWithPackage;
  let brandEnabledSwitchStoreUser = brandProfileData.enabledSwitchStoreUser;


  const [paymentQrCodeError, setPaymentQrCodeError] = useState("");

  const [loading, setLoading] = useState(false);

  const [isUpdating, setIsUpdating] = useState(id);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);

  const fetchStoreUser = (id) => {
    getBrandStoreById(id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreInfoData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const zero = 0;

  useEffect(() => {
    if (isUpdating !== null) {
      fetchStoreUser(isUpdating);
    }
  }, [isUpdating]);

  //  const [locationStore, setLocationStore] = useState({
  //    latitude: null,
  //    longitude: null,
  //    error: null,
  //  });

  // useEffect(() => {
  //   if ("geolocation" in navigator) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         setLocationStore({
  //           latitude: position.coords.latitude,
  //           longitude: position.coords.longitude,
  //           error: null,
  //         });
  //       },
  //       (error) => {
  //         setLocationStore((prev) => ({ ...prev, error: error.message }));
  //       }
  //     );
  //   } else {
  //     setLocationStore((prev) => ({
  //       ...prev,
  //       error: "Geolocation not supported",
  //     }));
  //   }
  // }, []);

  // const handleLocation = (latitude, longitude) => {

  //   let url = `https://maps.google.com?q=${latitude},${longitude}`;
  //   window.open(url);
  // };


  const gstTypeList = countryCode === "+91" ? ["including", "excluding", "composition"] : ["including", "excluding"];

  const [input, setInput] = useState({
    address: {
      addressLine1: "",
      addressLine2: "",
      landmark: "",
      latitude: "",
      longitude: "",
      currentLocation: "",
      pin: "",
      city: "",
      state: "",
    },
    gst: "",
    email: "",
    gstNo: "",
    gstType: "excluding",
    company: "",
    premium: false,
    mobileNo: "",
    storeName: "",
    linkShare: false,
    orderTrack: false,
    processTime: "",
    upiAccountId: "",
    upiAccountName: "",
    wareHouseModel: false,
    enabledLocality: false,
    enableCancelOrder: false,
    enabledUPIAccount: false,
    storeInvoiceGenNo: "",
    // enabledB2BModel: false,
    offerPriceEnabled: false,
    orderEditByStore: false,
    orderEditByRider: false,
    enabledReProcess: false,
    enabledRackModel: false,
    customerOfferDeal: false,
    storeInvoiceGenName: "",
    enabledStoreLoad: false,
    enabledLightVersion: false,
    packageCarryForward: false,
    enabledLoyaltyPoint: false,
    offerDiscountByStore: false,
    offerDiscountByRider: false,
    // storeB2bChallanGenName: "",
    enabledGSTControl: true,
    riderJobAutoAssigned: false,
    partialPaymentByRider: false,
    partialPaymentByStore: false,
    riderJobHandleEnabled: false,
    enabledMultiPriceList: false,
    enabledOldOrderFeature: false,
    notificationFooterInfo: "",
    enableDeliveryDiscount: false,
    enabledSmsNotification: false,
    scaccountHandleEnabled: false,
    enabledBackDate: false,
    enabledEditPayment: false,
    enabledQRDeviceModal: false,
    enabledProfileHandler: true,
    enabledAmountRoundOff: true,
    tagDeliveryDateInterval: zero,
    autoPackageCarryForward: true,
    enabledAutoCustomerId: false,
    enabledSwitchStoreUser: false,
    enabledPreDefinedRemark: false,
    enabledEditIncomeExpense: false,
    enabledEmailNotification: false,
    enableConsolidateInvoice: false,
    enabledCreatePaymentLink: false,
    enabledGarmentInspection: false,
    enableStoreInvoiceGenName: false,
    enableDeliveryVerification: false,
    enableRiderDeliveryDiscount: false,
    enabledAutoSelectAppService: false,
    enabledCustomDiscountCharge: false,
    enabledCustomerRevenueDetail: true,
    enabledCustomerRevenueDetailV2: true,
    enabledRiderPartialBooking: false,
    enabledNewPickupStoreNotified: false,
    enabledAddGarmentServicePrice: false,
    enabledChargeDiscountByService: false,
    enabledAddInternationalCustomer: false,
    enabledLoyaltyPointInSubscription: true,
    enableDeliveryVerificationByRider: false,
    enableDeliveryVerificationByStore: false,
    enableUserAccountDeliveryDiscount: false,
    enabledStoreCustomerBirthdayWishes: true,
    enabledSubscriptionDiscountAutoApply: false,
    enabledApplySubscriptionWithPackage: false,
    enabledAutoApplySubscriptionWithPackage: false,
    enabledSubscriptionDiscountOnDelivery: false,
  });

  useEffect(() => {

    let savedMobileNo = storeInfoData?.mobileNo;

    if (countryCode && storeInfoData?.mobileNo?.startsWith(countryCode)) {
      savedMobileNo = storeInfoData?.mobileNo?.replace(countryCode, "").trim();
    }

    setInput((prevState) => ({
      ...prevState,
      address: {
        addressLine1: storeInfoData?.address?.addressLine1 || "",
        addressLine2: storeInfoData?.address?.addressLine2 || "",
        landmark: storeInfoData?.address?.landmark || "",
        latitude: storeInfoData?.address?.latitude || "",
        longitude: storeInfoData?.address?.longitude || "",
        currentLocation: storeInfoData?.address?.currentLocation || "",
        pin: storeInfoData?.address?.pin || "",
        city: storeInfoData?.address?.city || "",
        state: storeInfoData?.address?.state || "",
      },
      gst: storeInfoData?.gst?.toString() || "",
      email: storeInfoData?.email || "",
      gstNo: storeInfoData?.gstNo || "",
      gstType: storeInfoData?.gstType || "excluding",
      company: storeInfoData?.company || "",
      premium: storeInfoData?.premium || false,
      mobileNo: savedMobileNo || "",
      storeName: storeInfoData?.storeName || "",
      linkShare: storeInfoData?.linkShare || false,
      orderTrack: storeInfoData?.orderTrack || false,
      processTime: storeInfoData?.processTime?.toString() || "",
      enableCancelOrder: storeInfoData?.enableCancelOrder || false,
      wareHouseModel: storeInfoData?.wareHouseModel || false,
      enabledLocality: storeInfoData?.enabledLocality || false,
      storeInvoiceGenNo: storeInfoData?.storeInvoiceGenNo?.toString() || "",
      offerPriceEnabled: storeInfoData?.offerPriceEnabled || false,
      orderEditByStore: storeInfoData?.orderEditByStore || false,
      orderEditByRider: storeInfoData?.orderEditByRider || false,
      enabledRackModel: storeInfoData?.enabledRackModel || false,
      customerOfferDeal: storeInfoData?.customerOfferDeal || false,
      storeInvoiceGenName: storeInfoData?.storeInvoiceGenName || "",
      enabledStoreLoad: storeInfoData?.enabledStoreLoad || false,
      enabledGSTControl: storeInfoData?.enabledGSTControl || false,
      enabledLightVersion: storeInfoData?.enabledLightVersion || false,
      packageCarryForward: storeInfoData?.packageCarryForward || false,
      enabledLoyaltyPoint: storeInfoData?.enabledLoyaltyPoint || false,
      offerDiscountByStore: storeInfoData?.offerDiscountByStore || false,
      offerDiscountByRider: storeInfoData?.offerDiscountByRider || false,
      riderJobAutoAssigned: storeInfoData?.riderJobAutoAssigned || false,
      // storeB2bChallanGenName: storeInfoData?.storeB2bChallanGenName || "",
      riderJobHandleEnabled: storeInfoData?.riderJobHandleEnabled || false,
      enabledMultiPriceList: storeInfoData?.enabledMultiPriceList || false,
      notificationFooterInfo: storeInfoData?.notificationFooterInfo || "",
      enableDeliveryDiscount: storeInfoData?.enableDeliveryDiscount || false,
      enabledSmsNotification: storeInfoData?.enabledSmsNotification || false,
      scaccountHandleEnabled: storeInfoData?.scaccountHandleEnabled || false,
      enabledBackDate: storeInfoData?.enabledBackDate || false,
      enabledEditPayment: storeInfoData?.enabledEditPayment || false,
      enabledEditIncomeExpense:
        storeInfoData?.enabledEditIncomeExpense || false,
      autoPackageCarryForward: storeInfoData?.autoPackageCarryForward || false,
      enabledAddInternationalCustomer:
        storeInfoData?.enabledAddInternationalCustomer || false,
      enabledAutoCustomerId:
        storeInfoData?.enabledAutoCustomerId || false,
      enabledNewPickupStoreNotified: storeInfoData.enabledNewPickupStoreNotified || false,
      enabledRiderPartialBooking:
        storeInfoData?.enabledRiderPartialBooking || false,
      enabledLoyaltyPointInSubscription:
        storeInfoData?.enabledLoyaltyPointInSubscription || false,
      enabledSwitchStoreUser: storeInfoData?.enabledSwitchStoreUser || false,
      enabledProfileHandler: storeInfoData?.enabledProfileHandler || false,
      enabledAmountRoundOff: storeInfoData?.enabledAmountRoundOff || false,
      enabledQRDeviceModal: storeInfoData?.enabledQRDeviceModal || false,
      enabledAddGarmentServicePrice:
        storeInfoData?.enabledAddGarmentServicePrice || false,
      enableStoreInvoiceGenName:
        storeInfoData?.enableStoreInvoiceGenName || false,
      enabledAutoSelectAppService:
        storeInfoData?.enabledAutoSelectAppService || false,
      enabledEmailNotification:
        storeInfoData?.enabledEmailNotification || false,
      enableConsolidateInvoice:
        storeInfoData?.enableConsolidateInvoice || false,
      enableDeliveryVerification:
        storeInfoData?.enableDeliveryVerification || false,
      enableDeliveryVerificationByRider:
        storeInfoData?.enableDeliveryVerificationByRider || false,
      enableDeliveryVerificationByStore:
        storeInfoData?.enableDeliveryVerificationByStore || false,
      enabledStoreCustomerBirthdayWishes:
        storeInfoData?.enabledStoreCustomerBirthdayWishes || false,

      upiAccountId: storeInfoData?.upiAccountId || "",
      upiAccountName: storeInfoData?.upiAccountName || "",
      enabledUPIAccount: storeInfoData?.enabledUPIAccount || false,
      partialPaymentByRider: storeInfoData?.partialPaymentByRider || false,
      enabledCreatePaymentLink:
        storeInfoData?.enabledCreatePaymentLink || false,
      enabledGarmentInspection:
        storeInfoData?.enabledGarmentInspection || false,
      enableUserAccountDeliveryDiscount:
        storeInfoData?.enableUserAccountDeliveryDiscount || false,
      partialPaymentByStore: storeInfoData?.partialPaymentByStore || false,
      enableRiderDeliveryDiscount:
        storeInfoData?.enableRiderDeliveryDiscount || false,

      enabledReProcess: storeInfoData?.enabledReProcess || false,
      tagDeliveryDateInterval:
        storeInfoData?.tagDeliveryDateInterval?.toString() || zero.toString(),
      enabledPreDefinedRemark: storeInfoData?.enabledPreDefinedRemark || false,
      enabledCustomerRevenueDetail:
        storeInfoData?.enabledCustomerRevenueDetail || false,
      enabledCustomerRevenueDetailV2: storeInfoData?.enabledCustomerRevenueDetailV2 || false,
      enabledChargeDiscountByService:
        storeInfoData?.enabledChargeDiscountByService || false,
      enabledCustomDiscountCharge:
        storeInfoData?.enabledCustomDiscountCharge || false,
      enabledSubscriptionDiscountOnDelivery:
        storeInfoData?.enabledSubscriptionDiscountOnDelivery || false,
      enabledSubscriptionDiscountAutoApply:
        storeInfoData?.enabledSubscriptionDiscountAutoApply || false,
      enabledOldOrderFeature: storeInfoData?.enabledOldOrderFeature || false,
      enabledApplySubscriptionWithPackage: storeInfoData?.enabledApplySubscriptionWithPackage || false,
      enabledAutoApplySubscriptionWithPackage: storeInfoData?.enabledAutoApplySubscriptionWithPackage || false,
      
      enabledB2BModel: storeInfoData?.enabledB2BModel || false,
    }));
  }, [storeInfoData]);

  // useEffect(() => {
  //   if (upiData !== null) {
  //     // setInput({
  //     //   ...input,
  //     //   upiAccountName: upiData.upiUserName,
  //     //   upiAccountId: upiData.upiId,
  //     // });
  //   }
  // }, [upiData]);

  const [storeNameError, setStoreNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [tagDeliveryDateIntervalError, setTagDeliveryDateIntervalError] =
    useState("");
  const [storeInvoiceGenNameError, setStoreInvoiceGenNameError] = useState("");
  const [storeInvoiceGenNoError, setStoreInvoiceGenNoError] = useState("");
  const [gstNoError, setGstNoError] = useState("");
  const [gstError, setGstError] = useState("");
  const [addressLineError, setAddressLineError] = useState("");
  const [stateError, setStateError] = useState("");
  const [pincodeError, setPincodeError] = useState("");

  const handleGstType = (value) => {
    const updatedInput = {
      ...input,
      gstType: value,
      gst: "",
    };

    if (value === "composition") {
      updatedInput.gst = 0;
    }

    if (updatedInput.gst === 0) {
      setGstError("");
    } else {
      setGstError("Please enter a valid " + storeLocalData?.taxType);
    }

    setInput(updatedInput);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0, image.width, image.height);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const qrCode = jsQR(
            imageData.data,
            imageData.width,
            imageData.height
          );

          if (qrCode) {
            const queryString = qrCode.data.split("?")[1]; // Get the part after '?'
            if (!queryString) {
              setPaymentQrCodeError(
                "Invalid Upi Qr Code Please Go Back And Come Again"
              );
              return;
            }

            // Manually parse query parameters
            const params = {};
            queryString.split("&").forEach((param) => {
              const [key, value] = param.split("=");
              params[key] = decodeURIComponent(value || "");
            });

            const upiData = {
              upiId: params.pa || "",
              upiUserName: params.pn || "",
            };

            setInput({
              ...input,
              upiAccountName: upiData.upiUserName,
              upiAccountId: upiData.upiId,
            });
          } else {
            setPaymentQrCodeError(
              "No Qr Code Found In Image Or Qr Code Image is Clear"
            );
          }
        };
      };
      reader.readAsDataURL(file);
    }
  };

  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemPress = () => {
    setSelectedItem((prevSelectedItem) => !prevSelectedItem);
  };

  const handleMobileNumberChange = (number) => {
    // Perform input validation to allow only Indian mobile numbers

    let isValidPartial = false;
    let isValidFull = false;
    let requiredLength = 10;

    // Validation based on country code
    if (countryCode === "+91") {
      // India: starts with 5-9 and max 10 digits
      isValidPartial = /^[5-9]\d{0,9}$/.test(number) || number === "";
      isValidFull = /^[5-9]\d{9}$/.test(number);
      requiredLength = 10;

    } else if (countryCode === "+971") {
      // UAE: starts with 5 and max 9 digits
      isValidPartial = /^5\d{0,8}$/.test(number) || number === "";
      isValidFull = /^5\d{8}$/.test(number);
      requiredLength = 9;
    }

    if (isValidPartial) {
      if (number.length === requiredLength) {
        setMobileNoError("");
      } else {
        setMobileNoError(`Please enter a ${requiredLength}-digit mobile number`);
      }

        setInput({
          ...input,
          mobileNo: number,
        });
    } else {
      setMobileNoError("Please enter a valid mobile number");
    }
  };

  const handleTagDeliveryDateInterval = (number) => {
    if (number.trim() === "") {
      setTagDeliveryDateIntervalError(
        "Tag Delivery Date Interval cannot be empty"
      );
      setIsButtonPressed(true);
    } else if (parseInt(number) >= parseInt(input.processTime)) {
      setTagDeliveryDateIntervalError(
        "Tag Delivery Date Interval must be less than process time"
      );
      setIsButtonPressed(true);
    } else {
      setTagDeliveryDateIntervalError(""); // Clear the error if validation passes
      setIsButtonPressed(false);
    }

    setInput({
      ...input,
      tagDeliveryDateInterval: number,
    });
  };

  const handleProcessTimeChange = (newProcessTime) => {
    setInput((prevState) => ({
      ...prevState,
      processTime: newProcessTime,
      tagDeliveryDateInterval: "0", // Reset tagDeliveryDateInterval to '0'
    }));
    setTagDeliveryDateIntervalError(""); // Clear any existing error
    setIsButtonPressed(false);
  };

  const handleDeliveryVerification = (value) => {
    // Perform input validation to allow only Indian mobile numbers
    if (!input.enableDeliveryVerification) {
      setInput({
        ...input,
        enableDeliveryVerification: !input.enableDeliveryVerification,
        enableDeliveryVerificationByRider: false,
        enableDeliveryVerificationByStore: false,
      });
    } else {
      setInput({
        ...input,
        enableDeliveryVerification: !input.enableDeliveryVerification,
      });
    }
  };

  const validateGST = (gst) => {

    let gstRegex = false;

    if (countryCode === "+91") {
      // India: starts with 5-9 and 10 digits
      gstRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    } else if (countryCode === "+971") {
      // UAE: 15 digits
      gstRegex = /^\d{15}$/;
    } else {
      // Fallback validation (digits only, length 6-15)
      gstRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    }

    // if(countryCode)
    // const gstRegex =
    //   /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return gstRegex.test(gst);
  };

  const isValidEmail = (email) => {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = () => {
    // Reset all previous errors

    setStoreNameError("");
    setEmailError("");
    setMobileNoError("");
    setStoreInvoiceGenNameError("");
    setStoreInvoiceGenNoError("");

    let isValid = true;
    if (!input.storeName) {
      setStoreNameError("Store Name is Required");
      isValid = false;
    }
    if (!input.email) {
      setEmailError("Email is Required");
      isValid = false;
    }
    if (!input.mobileNo) {
      setMobileNoError("Mobile Number is Required");
      isValid = false;
    }
    if (!input.storeInvoiceGenName) {
      setStoreInvoiceGenNameError("Invoice Gen Name is Required");
      isValid = false;
    }
    if (!input.storeInvoiceGenNo) {
      setStoreInvoiceGenNoError("Invoice Gen No. is required");
      isValid = false;
    } else if (input.storeInvoiceGenNo <= 0) {
      setStoreInvoiceGenNoError("No. must be grater then 0");
      isValid = false;
    }

    if (!input.address.addressLine1) {
      setAddressLineError("Address Line 1 is Required");
      isValid = false;
    }

    if (!input.address.state) {
      setStateError("State Name is Required");
      isValid = false;
    }

    if (!input.address.pin) {
      setPincodeError("Pin Code is Required");
      isValid = false;
    }


    if (gstNoError) {
      setGstNoError(storeLocalData?.taxType + " No is Required");
      isValid = false;
    }


    if (gstError) {
      setGstError(storeLocalData?.taxType + " is Required");
      isValid = false;
    }



    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          ...input,
          mobileNo: countryCode + input.mobileNo,
          brandId: brandId,
        };

        const UpdateData = {
          ...input,
          mobileNo: countryCode + input.mobileNo,
          brandId: brandId,
          id: storeInfoData?.id,
          status: storeInfoData.status,
        };

        // Call the service function for creating pickup request

        if (!isUpdating) {
          postBrandStore(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/StoreManagementList");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          putBrandStore(brandId, UpdateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/StoreManagementList");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/StoreManagementList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store {id ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      {/* <h2>Your Location:</h2>
      {locationStore.error ? (
        <p>Error: {locationStore.error}</p>
      ) : locationStore.latitude && locationStore.longitude ? (
        <p>
          Latitude: {locationStore.latitude} <br />
          Longitude: {locationStore.longitude}
        </p>
      ) : (
        <p>Getting location...</p>
      )}

      <div
        onClick={() =>
          handleLocation(locationStore.latitude, locationStore.longitude)
        }
      ><p>Map</p></div>*/}

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="storeName"
              value={input.storeName}
              onChange={(e) => {
                setInput({
                  ...input,
                  storeName: e.target.value,
                });
                setStoreNameError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {storeNameError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {storeNameError}
              </p>
            )}

            <label
              htmlFor="storeName"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Store Name <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="company"
              value={input.company}
              onChange={(e) => {
                setInput({
                  ...input,
                  company: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="company"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Company
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="email"
              value={input.email}
              onChange={(e) => {
                setInput({
                  ...input,
                  email: e.target.value,
                });
                if (!isValidEmail(e.target.value)) {
                  setEmailError("Please enter a valid email address");
                } else {
                  setEmailError("");
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {emailError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {emailError}
              </p>
            )}

            <label
              htmlFor="email"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Email Id <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="mobileNo"
              value={input.mobileNo}
              onChange={(e) => {
                handleMobileNumberChange(e.target.value);
              }}
              keyboardType="numeric"
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              maxLength={countryCode === "+971" ? countryCode.length + 9 : countryCode.length + 10}
            />
            {mobileNoError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {mobileNoError}
              </p>
            )}

            <label
              htmlFor="mobileNo"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Mobile Number <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="processTime"
              value={input.processTime}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  // Set the valid two-digit number
                  setInput({
                    ...input,
                    processTime: value,
                  });
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              keyboardType="numeric"
              maxLength={2} // Restrict input to 10 characters
            />
            <label
              htmlFor="processTime"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Process Time
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="InvoiceGenName"
              value={input.storeInvoiceGenName}
              onChange={(e) => {
                setInput({
                  ...input,
                  storeInvoiceGenName: e.target.value,
                });
                setStoreInvoiceGenNameError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {storeInvoiceGenNameError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {storeInvoiceGenNameError}
              </p>
            )}
            <label
              htmlFor="InvoiceGenName"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Invoice Gen Name <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="InvoiceGenNo"
              value={input.storeInvoiceGenNo}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  // Allows only numeric input
                  setInput({
                    ...input,
                    storeInvoiceGenNo: value,
                  });
                  setStoreInvoiceGenNoError(""); // Clear the error if input is valid
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {storeInvoiceGenNoError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {storeInvoiceGenNoError}
              </p>
            )}
            <label
              htmlFor="InvoiceGenNo"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Invoice Gen Number <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
        <div className="mx-4 mt-4  flex-1">
          {/* <FloatLabel>
            <InputText
              id="gstNo"
              value={input.gstNo}
              onChange={(e) => {
                setInput({
                  ...input,
                  gstNo: e.target.value,
                });
                if (!validateGST(e.target.value)) {
                  setGstNoError("Please enter a valid Gst No.");
                  setGstError("");
                  setInput({
                    ...input,
                    gst: "",
                  });
                } else {
                  setGstNoError("");
                  setGstError("Please enter a valid Gst No.");
                  setInput({
                    ...input,
                    gst: "",
                  });
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              maxLength={15}
            />
            <label
              htmlFor="gstNo"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Gst Number
            </label>
            </FloatLabel>*/}

          <FloatLabel>
            <InputText
              id="gstNo"
              value={input.gstNo}
              onChange={(e) => {
                const value = e.target.value;

                const isValid = validateGST(value);

                setInput((prev) => ({
                  ...prev,
                  gstNo: value,
                  gst: "",
                }));

                if (!isValid) {
                  if (value.length > 1) {
                    setGstNoError("Please enter a valid " + storeLocalData?.taxType + " No.");
                  } else {
                    setGstNoError("");
                  }
                  setGstError("");
                } else {
                  setGstNoError("");
                  setGstError("Please enter a valid " + storeLocalData?.taxType);
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{ backgroundColor: "#fff" }}
              maxLength={15}
            />
            <label
              htmlFor="gstNo"
              className="text-lg"
              style={{ color: "blue" }}
            >
              {storeLocalData?.taxType} Number
            </label>
          </FloatLabel>
          {gstNoError && (
            <p className="text-xl font-normal" style={{ color: "red" }}>
              {gstNoError}
            </p>
          )}
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="gst"
              value={input.gst}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setInput({
                    ...input,
                    gst: value,
                  });
                }

                if (value) {
                  setGstError("");
                } else {
                  setGstError("Please enter correct Value");
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              maxLength={2}
            />
            <label htmlFor="gst" className="text-lg" style={{ color: "blue" }}>
              {storeLocalData?.taxType} %
            </label>
          </FloatLabel>
          {gstError && (
            <p className="text-xl font-normal" style={{ color: "red" }}>
              {gstError}
            </p>
          )}
        </div>
        {input.gstNo && (
          <div className="mx-4 mt-4  flex-1">
            <FloatLabel>
              <Dropdown
                value={input.gstType}
                onChange={(e) => handleGstType(e.value)}
                options={gstTypeList}
                optionLabel="name"
                placeholder="{storeLocalData?.taxType} Type"
                className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
              />
              <label
                htmlFor="tagDeliveryDateInterval"
                className="text-lg"
                style={{ color: "blue" }}
              >
                {storeLocalData?.taxType} Type
              </label>
            </FloatLabel>
          </div>
        )}
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="tagDeliveryDateInterval"
              value={input.tagDeliveryDateInterval}
              onChange={(e) => {
                setInput({
                  ...input,
                  tagDeliveryDateInterval: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            <label
              htmlFor="tagDeliveryDateInterval"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Tag Delivery Date Interval
            </label>
          </FloatLabel>
        </div>
        {/*enabledB2BModelBrand && <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="storeB2bChallanGenName"
              value={input.storeB2bChallanGenName}
              onChange={(e) => {
                setInput({
                  ...input,
                  storeB2bChallanGenName: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            <label
              htmlFor="InvoiceGenName"
              className="text-lg"
              style={{ color: "blue" }}
            >
              B2b Challan Gen Name <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>*/}
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="upiAccountName"
              value={input.upiAccountName}
              onChange={(e) => {
                setInput({
                  ...input,
                  upiAccountName: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            <label
              htmlFor="upiAccountName"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Upi Account Name
            </label>
          </FloatLabel>
        </div>
        <div className="mx-4 mt-4  flex-1 ">
          <FloatLabel>
            <InputText
              id="upiAccountId"
              value={input.upiAccountId}
              onChange={(e) => {
                setInput({
                  ...input,
                  upiAccountId: e.target.value,
                });
              }}
              disabled={true}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            <label
              htmlFor="upiAccountId"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Upi Account Id
            </label>
          </FloatLabel>
        </div>
      </div>
      <div
        className="flex-1 shadow-2 p-2 m-4 border-2 border-round-xl cursor-pointer"
        style={{ borderColor: "#fff", backgroundColor: "#fff" }}
      >
        <div className="flex flex-row justify-content-between">
          <h2>Upload Your Payment QrCode Image Below</h2>
          <div className="flex flex-row-reverse ">
            <p
              className="text-lg font-medium underline ml-3 cursor-pointer"
              onClick={() => navigate("/UPIDisclaimer", { state: { id: id } })}
              style={{ color: "blue" }}
            >
              Disclaimer For Upi Id Storage & Liability
            </p>
            <div>
              <Checkbox checked={true} color={"#00A3FF"} size={20} />
            </div>
          </div>
        </div>
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        {paymentQrCodeError && (
          <p className="text-xl font-normal" style={{ color: "red" }}>
            {paymentQrCodeError}
          </p>
        )}
      </div>
      {/* address */}

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="addressLine1"
              value={input.address.addressLine1}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    addressLine1: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {addressLineError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {addressLineError}
              </p>
            )}

            <label
              htmlFor="addressLine1"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Address Line1 <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="addressLine2"
              value={input.address.addressLine2}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    addressLine2: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="addressLine2"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Address Line2
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="city"
              value={input.address.city}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    city: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label htmlFor="city" className="text-lg" style={{ color: "blue" }}>
              City
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="state"
              value={input.address.state}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    state: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {stateError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {stateError}
              </p>
            )}

            <label
              htmlFor="state"
              className="text-lg"
              style={{ color: "blue" }}
            >
              State <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="landMark"
              value={input.address.landmark}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    landmark: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="landMark"
              className="text-lg"
              style={{ color: "blue" }}
            >
              LandMark
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="pin"
              value={input.address.pin}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setInput({
                    ...input,
                    address: {
                      ...input.address,
                      pin: value,
                    },
                  });
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              keyboardType="numeric"
              maxLength={6}
            />

            {pincodeError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {pincodeError}
              </p>
            )}

            <label htmlFor="pin" className="text-lg" style={{ color: "blue" }}>
              Pin Code
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="latitude"
              value={input.address.latitude}
              onChange={(e) =>
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    latitude: e.target.value,
                  },
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="latitude"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Latitude
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="longitude"
              value={input.address.longitude}
              onChange={(e) => {
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    longitude: e.target.value,
                  },
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              keyboardType="numeric"
            />

            <label
              htmlFor="longitude"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Longitude
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="currentLocation"
              value={input.address.currentLocation}
              onChange={(e) => {
                setInput({
                  ...input,
                  address: {
                    ...input.address,
                    currentLocation: e.target.value,
                  },
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              keyboardType="numeric"
            />

            <label
              htmlFor="currentLocation"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Current Location
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="notificationFooterInfo"
              value={input.notificationFooterInfo}
              onChange={(e) =>
                setInput({
                  ...input,
                  notificationFooterInfo: e.target.value,
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="notificationFooterInfo"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Notification Note Message
            </label>
          </FloatLabel>
        </div>
      </div>

      <div
        className="shadow-2 m-3 border-2 border-round-lg cursor-pointer"
        style={{ borderColor: "#fff", backgroundColor: "#fff" }}
      >
        <div
          className="px-3 py-1  flex flex-row justify-content-between align-items-center cursor-pointer"
          style={{
            backgroundColor: "#fff",
          }}
          onClick={() => handleItemPress()}
        >
          <div className="flex justify-content-center align-items-center">
            <img
              className="flex justify-content-center align-items-center mr-3"
              src={
                "Laundy_App_Icons_Gifs/Other_Icons/Additional_Information.png"
              }
            />
            <p className="text-3xl font-bold capitalize">
              Additional Information
            </p>
          </div>

          <div>
            <i
              className={!selectedItem ? "pi pi-angle-down" : "pi pi-angle-up"}
              style={{
                fontSize: "25px",
                cursor: "pointer",
                color: "#000",
              }}
            ></i>
          </div>
        </div>
      </div>
      {selectedItem && (
        <div>
          <div>
            <div className="mx-3">
              <h3>Store Management</h3>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Partial Payment By Store</p>
                  <div>
                    <Checkbox
                      checked={input.partialPaymentByStore}
                      color={input.partialPaymentByStore ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          partialPaymentByStore: !input.partialPaymentByStore,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Enabled Upi Account</p>
                  <div>
                    <Checkbox
                      checked={input.enabledUPIAccount}
                      color={input.enabledUPIAccount ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledUPIAccount: !input.enabledUPIAccount,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Offer Price</p>
                  <div>
                    <Checkbox
                      checked={input.offerPriceEnabled}
                      color={input.offerPriceEnabled ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          offerPriceEnabled: !input.offerPriceEnabled,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">
                    Enable Store Invoice Gen Name
                  </p>
                  <div>
                    <Checkbox
                      checked={input.enableStoreInvoiceGenName}
                      color={
                        input.enableStoreInvoiceGenName ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enableStoreInvoiceGenName:
                            !input.enableStoreInvoiceGenName,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Enabled Re-Process</p>
                  <div>
                    <Checkbox
                      checked={input.enabledReProcess}
                      color={input.enabledReProcess ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledReProcess: !input.enabledReProcess,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Auto Select App Service</p>
                  <div>
                    <Checkbox
                      checked={input.enabledAutoSelectAppService}
                      color={
                        input.enabledAutoSelectAppService ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledAutoSelectAppService:
                            !input.enabledAutoSelectAppService,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">SCAccount Handle</p>
                  <div>
                    <Checkbox
                      checked={input.scaccountHandleEnabled}
                      color={input.scaccountHandleEnabled ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          scaccountHandleEnabled: !input.scaccountHandleEnabled,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Store Load</p>
                  <div>
                    <Checkbox
                      checked={input.enabledStoreLoad}
                      color={input.enabledStoreLoad ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledStoreLoad: !input.enabledStoreLoad,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Light Version</p>
                  <div>
                    <Checkbox
                      checked={input.enabledLightVersion}
                      color={input.enabledLightVersion ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledLightVersion: !input.enabledLightVersion,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Enabled Multi Tariff List</p>
                  <div>
                    <Checkbox
                      checked={input.enabledMultiPriceList}
                      color={input.enabledMultiPriceList ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledMultiPriceList: !input.enabledMultiPriceList,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">
                    Add Garment Service Price Using Store
                  </p>
                  <div>
                    <Checkbox
                      checked={input.enabledAddGarmentServicePrice}
                      color={
                        input.enabledAddGarmentServicePrice
                          ? "#00A3FF"
                          : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledAddGarmentServicePrice:
                            !input.enabledAddGarmentServicePrice,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Customer Revenue Detail</p>
                  <div>
                    <Checkbox
                      checked={input.enabledCustomerRevenueDetail}
                      color={
                        input.enabledCustomerRevenueDetail ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledCustomerRevenueDetail:
                            !input.enabledCustomerRevenueDetail,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Consolidate Invoice</p>
                  <div>
                    <Checkbox
                      checked={input.enableConsolidateInvoice}
                      color={
                        input.enableConsolidateInvoice ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enableConsolidateInvoice:
                            !input.enableConsolidateInvoice,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Cancel Order</p>
                  <div>
                    <Checkbox
                      checked={input.enableCancelOrder}
                      color={input.enableCancelOrder ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          enableCancelOrder: !input.enableCancelOrder,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>



            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">
                    Store Customer Birthday Wishes
                  </p>
                  <div>
                    <Checkbox
                      checked={input.enabledStoreCustomerBirthdayWishes}
                      color={
                        input.enabledStoreCustomerBirthdayWishes
                          ? "#00A3FF"
                          : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledStoreCustomerBirthdayWishes:
                            !input.enabledStoreCustomerBirthdayWishes,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Link Share</p>
                  <div>
                    <Checkbox
                      checked={input.linkShare}
                      color={input.linkShare ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          linkShare: !input.linkShare,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Email Notification</p>
                  <div>
                    <Checkbox
                      checked={input.enabledEmailNotification}
                      color={
                        input.enabledEmailNotification ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledEmailNotification:
                            !input.enabledEmailNotification,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">SMS Notification</p>
                  <div>
                    <Checkbox
                      checked={input.enabledSmsNotification}
                      color={input.enabledSmsNotification ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledSmsNotification: !input.enabledSmsNotification,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>





            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Premium</p>
                  <div>
                    <Checkbox
                      checked={input.premium}
                      color={input.premium ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          premium: !input.premium,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">New Pickup Store Notified</p>
                  <div>
                    <Checkbox
                      checked={input.enabledNewPickupStoreNotified}
                      color={
                        input.enabledNewPickupStoreNotified ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledNewPickupStoreNotified: !input.enabledNewPickupStoreNotified,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>


            {/*  */}
            <div className="flex flex-1">
              {enabledGarmentAttribute && (
                <div
                  className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                  style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                >
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Pre Defined Remark</p>
                    <div>
                      <Checkbox
                        checked={input.enabledPreDefinedRemark}
                        color={
                          input.enabledPreDefinedRemark ? "#00A3FF" : "#C1C9D3"
                        }
                        onClick={() =>
                          setInput({
                            ...input,
                            enabledPreDefinedRemark:
                              !input.enabledPreDefinedRemark,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                </div>
              )}
              {enabledBrandLocality && (
                <div
                  className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                  style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                >
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Enabled Locality</p>
                    <div>
                      <Checkbox
                        checked={input.enabledLocality}
                        color={input.enabledLocality ? "#00A3FF" : "#C1C9D3"}
                        onClick={() =>
                          setInput({
                            ...input,
                            enabledLocality: !input.enabledLocality,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/*  */}

            <div className="flex flex-1">
              {brandProfileData.wareHouseModel && (
                <div
                  className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                  style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                >
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Store-Warehouse Modal</p>
                    <div>
                      <Checkbox
                        checked={input.wareHouseModel}
                        color={input.wareHouseModel ? "#00A3FF" : "#C1C9D3"}
                        onClick={() =>
                          setInput({
                            ...input,
                            wareHouseModel: !input.wareHouseModel,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                </div>
              )}
              {orderEditModel && (
                <div
                  className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                  style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                >
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Order Track</p>
                    <div>
                      <Checkbox
                        checked={input.orderTrack}
                        color={input.orderTrack ? "#00A3FF" : "#C1C9D3"}
                        onClick={() =>
                          setInput({
                            ...input,
                            orderTrack: !input.orderTrack,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>

                </div>
              )}
            </div>

            {/*  */}
            <div className="flex flex-1">
              {enabledBrandGarmentInspection && (
                <div
                  className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                  style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                >
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Garment Inspection</p>
                    <div>
                      <Checkbox
                        checked={input.enabledGarmentInspection}
                        color={
                          input.enabledGarmentInspection ? "#00A3FF" : "#C1C9D3"
                        }
                        onClick={() =>
                          setInput({
                            ...input,
                            enabledGarmentInspection:
                              !input.enabledGarmentInspection,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                </div>
              )}
              {enabledCustomerPreferencePrice && (
                <div
                  className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                  style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                >
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Customer Offer Deal</p>
                    <div>
                      <Checkbox
                        checked={input.customerOfferDeal}
                        color={input.customerOfferDeal ? "#00A3FF" : "#C1C9D3"}
                        onClick={() =>
                          setInput({
                            ...input,
                            customerOfferDeal: !input.customerOfferDeal,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/*  */}

            <div className="flex flex-1">
              {enabledBrandOldOrderFeature && (
                <div
                  className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                  style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                >
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Old Order Feature</p>
                    <div>
                      <Checkbox
                        checked={input.enabledOldOrderFeature}
                        color={
                          input.enabledOldOrderFeature ? "#00A3FF" : "#C1C9D3"
                        }
                        onClick={() =>
                          setInput({
                            ...input,
                            enabledOldOrderFeature: !input.enabledOldOrderFeature,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                </div>
              )}
              {enabledPaymentGateway && (
                <div
                  className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                  style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                >
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Create Payment Link</p>
                    <div>
                      <Checkbox
                        checked={input.enabledCreatePaymentLink}
                        color={
                          input.enabledCreatePaymentLink ? "#00A3FF" : "#C1C9D3"
                        }
                        onClick={() =>
                          setInput({
                            ...input,
                            enabledCreatePaymentLink:
                              !input.enabledCreatePaymentLink,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>



            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Edit Income Expense</p>
                  <div>
                    <Checkbox
                      checked={input.enabledEditIncomeExpense}
                      color={
                        input.enabledEditIncomeExpense ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledEditIncomeExpense:
                            !input.enabledEditIncomeExpense,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Auto Customer Id</p>
                  <div>
                    <Checkbox
                      checked={input.enabledAutoCustomerId}
                      color={
                        input.enabledAutoCustomerId ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledAutoCustomerId: !input.enabledAutoCustomerId,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Enabled Back Date</p>
                  <div>
                    <Checkbox
                      checked={input.enabledBackDate}
                      color={input.enabledBackDate ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledBackDate: !input.enabledBackDate,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">
                    Add International Customer
                  </p>
                  <div>
                    <Checkbox
                      checked={input.enabledAddInternationalCustomer}
                      color={
                        input.enabledAddInternationalCustomer
                          ? "#00A3FF"
                          : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledAddInternationalCustomer:
                            !input.enabledAddInternationalCustomer,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                {enabledLoyaltyPointBrand && (
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Loyalty Point</p>
                    <div>
                      <Checkbox
                        checked={input.enabledLoyaltyPoint}
                        color={input.enabledLoyaltyPoint ? "#00A3FF" : "#C1C9D3"}
                        onClick={() =>
                          setInput({
                            ...input,
                            enabledLoyaltyPoint: !input.enabledLoyaltyPoint,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                {/*enabledB2BModelBrand && (
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Enabled B2B Model</p>
                    <div>
                      <Checkbox
                        checked={input.enabledB2BModel}
                        color={input.enabledB2BModel ? "#00A3FF" : "#C1C9D3"}
                        onClick={() =>
                          setInput({
                            ...input,
                            enabledB2BModel: !input.enabledB2BModel,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                )*/}
                {enabledRackModelBrand && (
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">Enabled Rack Model</p>
                    <div>
                      <Checkbox
                        checked={input.enabledRackModel}
                        color={input.enabledRackModel ? "#00A3FF" : "#C1C9D3"}
                        onClick={() =>
                          setInput({
                            ...input,
                            enabledRackModel: !input.enabledRackModel,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="flex flex-1">

              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                {brandEnabledSwitchStoreUser && <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Enabled Switch Store User</p>
                  <div>
                    <Checkbox
                      checked={input.enabledSwitchStoreUser}
                      color={
                        input.enabledSwitchStoreUser ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledSwitchStoreUser:
                            !input.enabledSwitchStoreUser,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>}
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Enabled Qr Device Modal</p>
                  <div>
                    <Checkbox
                      checked={input.enabledQRDeviceModal}
                      color={
                        input.enabledQRDeviceModal ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledQRDeviceModal:
                            !input.enabledQRDeviceModal,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>


            <div className="flex flex-1">

              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Enabled {storeLocalData?.taxType} control</p>
                  <div>
                    <Checkbox
                      checked={input.enabledGSTControl}
                      color={
                        input.enabledGSTControl ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledGSTControl:
                            !input.enabledGSTControl,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Enabled Customer Revenue Detail V2</p>
                  <div>
                    <Checkbox
                      checked={input.enabledCustomerRevenueDetailV2}
                      color={
                        input.enabledCustomerRevenueDetailV2 ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledCustomerRevenueDetailV2:
                            !input.enabledCustomerRevenueDetailV2,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>


            <div className="flex flex-1">

              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Enabled Profile Handler</p>
                  <div>
                    <Checkbox
                      checked={input.enabledProfileHandler}
                      color={
                        input.enabledProfileHandler ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledProfileHandler:
                            !input.enabledProfileHandler,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>

              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Enabled Amount Round Off</p>
                  <div>
                    <Checkbox
                      checked={input.enabledAmountRoundOff}
                      color={
                        input.enabledAmountRoundOff ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledAmountRoundOff:
                            !input.enabledAmountRoundOff,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>

            </div>



          </div>

          <div>
            <div className="mx-3">
              <h3>Subscriptions Management</h3>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">
                    Subscription Discount On Delivery
                  </p>
                  <div>
                    <Checkbox
                      checked={input.enabledSubscriptionDiscountOnDelivery}
                      color={
                        input.enabledSubscriptionDiscountOnDelivery
                          ? "#00A3FF"
                          : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledSubscriptionDiscountOnDelivery:
                            !input.enabledSubscriptionDiscountOnDelivery,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">
                    Subscription Discount Auto Apply
                  </p>
                  <div>
                    <Checkbox
                      checked={input.enabledSubscriptionDiscountAutoApply}
                      color={
                        input.enabledSubscriptionDiscountAutoApply
                          ? "#00A3FF"
                          : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledSubscriptionDiscountAutoApply:
                            !input.enabledSubscriptionDiscountAutoApply,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-1">
              {enabledApplySubscriptionWithPackageBrand && <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Apply Subscription With Package</p>
                  <div>
                    <Checkbox
                      checked={input.enabledApplySubscriptionWithPackage}
                      color={
                        input.enabledApplySubscriptionWithPackage ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledApplySubscriptionWithPackage: !input.enabledApplySubscriptionWithPackage,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>}
              {enabledAutoApplySubscriptionWithPackageBrand && <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Auto Apply Subscription With Package</p>
                  <div>
                    <Checkbox
                      checked={input.enabledAutoApplySubscriptionWithPackage}
                      color={
                        input.enabledAutoApplySubscriptionWithPackage ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledAutoApplySubscriptionWithPackage: !input.enabledAutoApplySubscriptionWithPackage,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>

              </div>}
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                {enabledLoyaltyPointBrand && (<div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">
                    Loyalty Point in Subscription
                  </p>
                  <div>
                    <Checkbox
                      checked={input.enabledLoyaltyPointInSubscription}
                      color={
                        input.enabledLoyaltyPointInSubscription
                          ? "#00A3FF"
                          : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledLoyaltyPointInSubscription:
                            !input.enabledLoyaltyPointInSubscription,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>)}

              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >

              </div>
            </div>
          </div>

          <div>
            <div className="mx-3">
              <h3>Order Edit</h3>
            </div>
            {orderEditModel && (
              <div>
                <div className="flex flex-1">
                  <div
                    className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                    style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                  >
                    <div className="flex justify-content-between align-items-center">
                      <p className="text-lg font-medium">Order Edit By Store</p>
                      <div>
                        <Checkbox
                          checked={input.orderEditByStore}
                          color={input.orderEditByStore ? "#00A3FF" : "#C1C9D3"}
                          onClick={() =>
                            setInput({
                              ...input,
                              orderEditByStore: !input.orderEditByStore,
                            })
                          }
                          size={20}
                        />
                      </div>
                    </div>

                  </div>

                  <div
                    className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                    style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                  >
                    <div className="flex justify-content-between align-items-center">
                      <p className="text-lg font-medium"> Order Edit By Rider</p>
                      <div>
                        <Checkbox
                          checked={input.orderEditByRider}
                          color={input.orderEditByRider ? "#00A3FF" : "#C1C9D3"}
                          onClick={() =>
                            setInput({
                              ...input,
                              orderEditByRider: !input.orderEditByRider,
                            })
                          }
                          size={20}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Edit Payment</p>
                  <div>
                    <Checkbox
                      checked={input.enabledEditPayment}
                      color={input.enabledEditPayment ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledEditPayment: !input.enabledEditPayment,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>

              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >

              </div>
            </div>
          </div>

          <div>
            <div className="mx-3">
              <h3>Charges & Discounts</h3>
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Offer Discount By Rider</p>
                  <div>
                    <Checkbox
                      checked={input.offerDiscountByRider}
                      color={input.offerDiscountByRider ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          offerDiscountByRider: !input.offerDiscountByRider,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Delivery Discount</p>
                  <div>
                    <Checkbox
                      checked={input.enableDeliveryDiscount}
                      color={input.enableDeliveryDiscount ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          enableDeliveryDiscount: !input.enableDeliveryDiscount,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">
                    User Account Delivery Discount
                  </p>
                  <div>
                    <Checkbox
                      checked={input.enableUserAccountDeliveryDiscount}
                      color={
                        input.enableUserAccountDeliveryDiscount
                          ? "#00A3FF"
                          : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enableUserAccountDeliveryDiscount:
                            !input.enableUserAccountDeliveryDiscount,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Offer Discount By Store</p>
                  <div>
                    <Checkbox
                      checked={input.offerDiscountByStore}
                      color={input.offerDiscountByStore ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          offerDiscountByStore: !input.offerDiscountByStore,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Rider Delivery Discount</p>
                  <div>
                    <Checkbox
                      checked={input.enableRiderDeliveryDiscount}
                      color={
                        input.enableRiderDeliveryDiscount ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enableRiderDeliveryDiscount:
                            !input.enableRiderDeliveryDiscount,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Custom Charges</p>
                  <div>
                    <Checkbox
                      checked={input.enabledChargeDiscountByService}
                      color={
                        input.enabledChargeDiscountByService
                          ? "#00A3FF"
                          : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledChargeDiscountByService:
                            !input.enabledChargeDiscountByService,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Custom Discount</p>
                  <div>
                    <Checkbox
                      checked={input.enabledCustomDiscountCharge}
                      color={
                        input.enabledCustomDiscountCharge ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledCustomDiscountCharge:
                            !input.enabledCustomDiscountCharge,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >

              </div>
            </div>
          </div>

          <div>
            <div className="mx-3">
              <h3>Delivery Verification</h3>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Delivery Verification</p>
                  <div>
                    <Checkbox
                      checked={input.enableDeliveryVerification}
                      color={
                        input.enableDeliveryVerification ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enableDeliveryVerification:
                            !input.enableDeliveryVerification,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >

              </div>
            </div>
            {input.enableDeliveryVerification && (
              <div className="flex flex-1">
                <div
                  className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                  style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                >
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">
                      Delivery Verification By Store
                    </p>
                    <div>
                      <Checkbox
                        checked={input.enableDeliveryVerificationByStore}
                        color={
                          input.enableDeliveryVerificationByStore
                            ? "#00A3FF"
                            : "#C1C9D3"
                        }
                        onClick={() =>
                          setInput({
                            ...input,
                            enableDeliveryVerificationByStore:
                              !input.enableDeliveryVerificationByStore,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                  style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                >
                  <div className="flex justify-content-between align-items-center">
                    <p className="text-lg font-medium">
                      Delivery Verification By Rider
                    </p>
                    <div>
                      <Checkbox
                        checked={input.enableDeliveryVerificationByRider}
                        color={
                          input.enableDeliveryVerificationByRider
                            ? "#00A3FF"
                            : "#C1C9D3"
                        }
                        onClick={() =>
                          setInput({
                            ...input,
                            enableDeliveryVerificationByRider:
                              !input.enableDeliveryVerificationByRider,
                          })
                        }
                        size={20}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {packageCarryForwardBrand && (
              <div>
                <div className="mx-3">
                  <h3>Package Carry Forward</h3>
                </div>
                <div className="flex flex-1">
                  <div
                    className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                    style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                  >
                    <div className="flex justify-content-between align-items-center">
                      <p className="text-lg font-medium">Package Carry Forward</p>
                      <div>
                        <Checkbox
                          checked={input.packageCarryForward}
                          color={input.packageCarryForward ? "#00A3FF" : "#C1C9D3"}
                          onClick={() =>
                            setInput({
                              ...input,
                              packageCarryForward: !input.packageCarryForward,
                            })
                          }
                          size={20}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                    style={{ borderColor: "#fff", backgroundColor: "#fff" }}
                  >
                    <div className="flex justify-content-between align-items-center">
                      <p className="text-lg font-medium">
                        Auto Package Carry Forward
                      </p>
                      <div>
                        <Checkbox
                          checked={input.autoPackageCarryForward}
                          color={
                            input.autoPackageCarryForward ? "#00A3FF" : "#C1C9D3"
                          }
                          onClick={() =>
                            setInput({
                              ...input,
                              autoPackageCarryForward:
                                !input.autoPackageCarryForward,
                            })
                          }
                          size={20}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div>
            <div className="mx-3">
              <h3>Rider</h3>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Rider Job Auto Assigned</p>
                  <div>
                    <Checkbox
                      checked={input.riderJobAutoAssigned}
                      color={input.riderJobAutoAssigned ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          riderJobAutoAssigned: !input.riderJobAutoAssigned,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Rider Job Handle</p>
                  <div>
                    <Checkbox
                      checked={input.riderJobHandleEnabled}
                      color={input.riderJobHandleEnabled ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          riderJobHandleEnabled: !input.riderJobHandleEnabled,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-1">
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >
                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Rider Partial Booking</p>
                  <div>
                    <Checkbox
                      checked={input.enabledRiderPartialBooking}
                      color={
                        input.enabledRiderPartialBooking ? "#00A3FF" : "#C1C9D3"
                      }
                      onClick={() =>
                        setInput({
                          ...input,
                          enabledRiderPartialBooking:
                            !input.enabledRiderPartialBooking,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>
              </div>
              <div
                className="flex-1 shadow-2 m-3 p-2 border-2 border-round-lg cursor-pointer"
                style={{ borderColor: "#fff", backgroundColor: "#fff" }}
              >

                <div className="flex justify-content-between align-items-center">
                  <p className="text-lg font-medium">Partial Payment By Rider</p>
                  <div>
                    <Checkbox
                      checked={input.partialPaymentByRider}
                      color={input.partialPaymentByRider ? "#00A3FF" : "#C1C9D3"}
                      onClick={() =>
                        setInput({
                          ...input,
                          partialPaymentByRider: !input.partialPaymentByRider,
                        })
                      }
                      size={20}
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      )}
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default StoreManagementCreate;
